import { render, staticRenderFns } from "./ConfirmDialogAddClient.vue?vue&type=template&id=76372e34"
import script from "./ConfirmDialogAddClient.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogAddClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports